import OBase from './OBase';

import * as Geometry from '../geometry';

export default class ShiftList extends OBase {
  update () {
    let lValTree = this.getObjectInput('List');
    let sValTree = this.getFloatInput('Shift');
    let wValTree = this.getBoolInput('Wrap');

    let lOutput = this.getGenericObjectOutput('List');

    let outDataTrees = [];
    Geometry.makeMultiplePairs([sValTree, wValTree], outDataTrees);

    let lOutTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let shift = outDataTrees[0].branches[i][j];
        let wrap = outDataTrees[1].branches[i][j];
        let path = outDataTrees[0].paths[i];

        for (let k = 0; k < lValTree.branches.length; k++) {
          let list = lValTree.branches[k];
          let lpath = lValTree.paths[k];

          /*
          let newList = []
          if (shift > 0) {
            let sublist = list.slice(0, shift)
            newList = list.slice(shift, list.length)
            if (wrap) {
              newList = newList.concat(sublist)
            }
          } else {
            let sublist = list.slice(list.length + shift, list.length - 1)
            list = list.slice(0, list.length + shift)
            if (wrap) {
              newList = newList.concat(sublist)
            }
            newList = newList.concat(list)
          }
          */

          let len = list.length;
          let newList = [];
          for (let l = 0; l < len; l++) {
            let idx = l + shift;
            if (!wrap && (idx < 0 || idx >= len)) continue;

            if (idx < 0) {
              idx = len + idx;
            } else if (idx >= len) {
              idx = idx % len;
            }
            newList.push(list[idx]);
          }

          let outPath = new Geometry.GHPath();
          if (true) {
            outPath = new Geometry.GHPath(lpath);
          } else {
            outPath = new Geometry.GHPath(path);
            outPath.add(lValTree.paths[k]);
          }

          outPath.add(0);
          for (let l = 0; l < newList.length; l++) {
            let item = newList[l];
            lOutTree.add(item, outPath);
          }
        }
      }
    }

    lOutput.value = lOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ShiftList.js